module.exports = __webpack_public_path__ + "img/ic-motor.677d7719.svg";